import * as React from 'react';

import NotesStar140 from './NotesStar140';

export const notesStar140 = () => <NotesStar140 />;

export default {
    title: 'Illustration/NotesStar140',
    component: NotesStar140,
    parameters: {
        notes: "`import NotesStar140 from 'box-ui-elements/es/illustration/NotesStar140';`",
    },
};
